import {TFIAccount, TFIFolderServerResponse, TFRevsByTFIMetaId} from 'notebook/tfi/TFIConstants';
import {FromServerNoteLinkedFile} from 'notebook/util/NoteUtilConstants';
import * as net from 'util/Net';
import type {BetterJQueryPromise} from 'util/Promises';
import * as TaskRunner from 'util/TaskRunner';

const TFIDAO = {
  fetchAccounts: (): BetterJQueryPromise<{data: Array<TFIAccount>}> => net.getJSON('/1/api/tfi/accounts/'),

  deleteAccount: (accountId: string): JQueryPromise<{}> =>
    net.delete_({url: `/1/api/tfi/accounts/${accountId}`}),

  listFolder: (accountId: string, folderId: string | null): BetterJQueryPromise<TFIFolderServerResponse> =>
    net.getJSON(`/1/api/tfi/accounts/${accountId}/actions/list`, {folderId}),

  importFile: ({
    accountId,
    fileId,
    fileName,
  }: {
    accountId: string;
    fileId: string;
    fileName: string;
  }): JQueryPromise<{noteLinkedObject: FromServerNoteLinkedFile}> => {
    const data = JSON.stringify({
      tfiAccount: accountId,
      thirdpartyFileId: fileId,
      fileName,
    });
    return TaskRunner.runTask({
      type: 'POST',
      url: '/1/api/tfi/actions/import',
      contentType: 'application/json',
      dataType: 'json',
      data,
    });
  },

  previewFile: (accountId: string, fileId: string): JQueryPromise<string> =>
    net.getJSON('/1/api/tfi/actions/preview', {accountId, fileId}),

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  search: (query: string | null, limit: number, accountId: string | null) =>
    net.getJSON('/1/api/tfi/actions/search', {query, limit, accountId}),

  bulkGetUpstreamThirdpartyFileRev: ({
    tfiFileMetaIds,
  }: {
    tfiFileMetaIds: Array<number>;
  }): BetterJQueryPromise<TFRevsByTFIMetaId> =>
    TaskRunner.runTask(
      {
        url: `/1/api/tfi/upstream-thirdparty-file-revs:bulk-get`,
        // Maintain this as comma-separated string as otherwise JSON string deserialization will happen twice and mess up the URL encoding that Flask is parsing in its request handler
        data: {tfiFileMetaIds: tfiFileMetaIds.join(',')},
        type: 'GET',
        contentType: 'application/json',
      },
      60000
    ),
};

export default TFIDAO;
